const gridHorizontalScrollEvent = 'grid-h-scroll';

export { gridHorizontalScrollEvent };
//# sourceMappingURL=scrollUtils.js.map
